// SPDX-License-Identifier: BUSL-1.1

export const ORGS_QUERY_KEY = ['orgs'] as const;
export const AGENTS_QUERY_KEY = ['agents'] as const;
export const CONFIGS_QUERY_KEY = ['configs'] as const;
export const FLAGS_QUERY_KEY = ['flags'] as const;
export const MODERATION_PENDING_COUNT_QUERY_KEY = ['moderation', 'pending-count'] as const;
export const AUDIT_RECENT_5_QUERY_KEY = ['audit', 'recent', 5] as const;
export const AUDIT_RECENT_8_QUERY_KEY = ['audit', 'recent', 8] as const;
export const HEALTH_QUERY_KEY = ['health'] as const;

export const ORG_SCOPED_BOOTSTRAP_QUERY_KEYS = [
  AGENTS_QUERY_KEY,
  CONFIGS_QUERY_KEY,
  FLAGS_QUERY_KEY,
  MODERATION_PENDING_COUNT_QUERY_KEY,
  AUDIT_RECENT_5_QUERY_KEY,
  AUDIT_RECENT_8_QUERY_KEY,
] as const;

export function queryKeyLabel(queryKey: readonly unknown[]): string {
  return JSON.stringify(queryKey);
}
